export const setCookie = ({
  name,
  value,
  days
}: {
  name: string;
  value: string | boolean | number;
  days?: number;
}): void => {
  const stringValue = typeof value === 'boolean' ? value.toString() : value.toString();
  // eslint-disable-next-line no-console
  console.log("string value in helper function:", stringValue);
  const expires = days
    ? `; expires=${new Date(Date.now() + days * 86400000).toUTCString()}`
    : '';
  document.cookie = `${name}=${encodeURIComponent(stringValue)}${expires}; path=/`;
};


export const getCookie = (name: string): string | boolean | null => {
  const cookies = document.cookie.split('; ');
  const cookie = cookies.find((c) => c.startsWith(`${name}=`));
  if (!cookie) {
    return null;
  }
  const value = decodeURIComponent(cookie.split('=')[1]);
  return value === 'true' ? true : value === 'false' ? false : value;
};
